import semverCompare from 'semver-compare';

const sortVersionStrings = (versions: Array<string>): Array<string> => {
  return [...versions].sort(semverCompare).reverse();
};

const sortVersionObjects = <T extends { version: string }>(versions: T[]) => {
  const copiedVersions = [...versions]
    .sort((objA, objB) => semverCompare(objA.version, objB.version))
    .reverse();
  return copiedVersions;
};

const versionIncrementors = [
  // patch
  (versionParts: Array<number>) => {
    return [versionParts[0], versionParts[1], versionParts[2] + 1].join('.');
  },
  // minor
  (versionParts: Array<number>) => {
    return [versionParts[0], versionParts[1] + 1, 0].join('.');
  },
  // major
  (versionParts: Array<number>) => {
    return [versionParts[0] + 1, 0, 0].join('.');
  },
];
const versionLabels = ['Patch', 'Minor', 'Major'];

const incrementVersion = (
  version: string // must be in the form a.b.c
): Array<{ value: string; label: string }> => {
  const versionParts = version.split('.').map(i => parseInt(i, 10));

  return versionIncrementors.map((incrementor, index) => {
    const newVersion = incrementor(versionParts);
    return {
      value: newVersion,
      label: `${newVersion} (${versionLabels[index]})`,
    };
  });
};

export { incrementVersion, sortVersionObjects, sortVersionStrings };
